import { ICellRendererParams } from 'ag-grid-community';
import { TokenBalance } from '../../types';

// Pre-create formatters for performance (expensive to create repeatedly)
const highPrecisionPriceFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 6,
});

const lowPrecisionPriceFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const PriceCellRenderer = (
  params: ICellRendererParams<TokenBalance>,
) => {
  const price = params.value as number;

  if (price === null || price === undefined) {
    return <span className="text-muted-foreground">-</span>;
  }

  // Use pre-created formatters for better performance
  const formatter =
    price < 1 ? highPrecisionPriceFormatter : lowPrecisionPriceFormatter;
  const formattedPrice = formatter.format(price);

  return <span>{formattedPrice}</span>;
};
